import { useSelector } from 'react-redux';

import { can } from '#/modules/infra/auth/can';

/**
 * @param {string} code
 * @returns {boolean}
 */
export function useCan(code) {
  const permissions = useSelector((state) => state.infra.permissions);
  return can(permissions, code);
}
